import { GET } from '@/shared/api/requests';
import type { ProjectSummary } from '../types';

export const getProjectSummary = async (projectId: number): Promise<ProjectSummary> => {
  const response = await GET(`/base/projects/${projectId}/summary/`);
  return response.data as ProjectSummary;
};
